import { render } from "./FooterStyleThree.vue?vue&type=template&id=555dc13e"
import script from "./FooterStyleThree.vue?vue&type=script&lang=js"
export * from "./FooterStyleThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__